export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img11-e4699078d7438145e314e55d45ceb054.png";